import { createNextTableContext } from '@core/table';

export const CashRegistersTableContext = createNextTableContext();
